




import { defineComponent } from '@nuxtjs/composition-api';
import { useLocales } from '@/composables';
import DcwTextPageLayout from '@/components/Layouts/TextPage/DcwTextPageLayout.vue';

export default defineComponent({
  components: {
    DcwTextPageLayout
  },
  layout: 'Default',
  setup() {
    const { translation } = useLocales();

    return { translation };
  },
  nuxtI18n: {
    locales: ['en']
  },
  head: {}
});
